import {Drawer, DrawerProps, ScrollArea} from '@mantine/core';
import {RecordForm} from '../forms/RecordForm';
import {SetupIntent} from '../types';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: SetupIntent,
        handleSubmit: (values: SetupIntent) => void | Promise<unknown>
    }) => {

    const title = record?.id ? 'Edit Setup Intent' : 'Add Setup Intent';

    /**
     * ⚠️ FNP-918: the drawer closes ONLY on success.
     *
     * `handleSubmit` is now `mutateAsync`, which rejects when the mutation
     * fails. Previously it was `mutate`, which returned void — so the await
     * resolved immediately and `onClose()` ran while the request was still in
     * flight, closing the drawer whatever the outcome. On a failure the
     * operator saw an error notification with their input already gone.
     *
     * Re-throwing lets RecordForm's own catch reset Formik's `isSubmitting`;
     * swallowing it here would leave the form wedged.
     */
    const handleFormSubmit = async (values: SetupIntent) => {
        await handleSubmit(values);
        onClose();
    };

    return (
        <Drawer
            transitionProps={{
                transition: 'slide-left',
                duration: 750,
                timingFunction: 'ease'
            }}
            position="right"
            offset={10}
            opened={opened}
            onClose={onClose}
            title={title}
            padding="xl"
            size="xl"
            scrollAreaComponent={ScrollArea.Autosize}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </Drawer>
    );
};
